import cn from 'classnames'

import style from '../PaymentMethods.module.scss'

export const Cash = () => (
  <div className={style.cash}>
    <h2 className={style.bm} id="cash">Оплата услуг наличными деньгами</h2>
    <p className={style.bm_text}>Наличными деньгами в отделениях следующих банков:</p>

    <div className={style.banks}>
      <div className={style.text_container}>
        <ul className={cn(style.before, style.second)}>
          <li><a href="https://absolutbank.by/">Абсолютбанк</a></li>
          <li><a href="https://www.btabank.by/">БТА Банк</a></li>
          <li><a href="https://www.belapb.by/">Белагропромбанк</a></li>
          <li><a href="https://www.bveb.by/">Белвнешэкономбанк</a></li>
          <li><a href="https://www.belgazprombank.by/">Белгазпромбанк</a></li>
          <li><a href="https://www.belinvestbank.by/">Белинвестбанк</a></li>
          <li><a href="https://www.deltabank.by/">Дельта Банк</a></li>
        </ul>
        <ul>
          <li><a href="https://www.bnb.by/">Народный банк</a></li>
          <li><a href="https://www.paritetbank.by/">Паритетбанк</a></li>
          <li><a href="https://sbb.by/">Сомбелбанк</a></li>
          <li><a href="https://vtb-bank.by/">ВТБ Банк</a></li>
          <li><a href="https://www.bsb.by/">БелСвиссБанк</a></li>
          <li><a href="https://www.bpsb.by/">Белпромстройбанк</a></li>
          <li><a href="https://qiwi.by/kart/">Платежные терминалы ОСМП</a></li>
        </ul>
      </div>
    </div>

    <p className={style.f_p}>
      В сети салонов
      <span>
        <a
          href="https://svyaznoy.by/info/shop-adress"
        >
          «Связной»
        </a>
      </span>
    </p>
    <p className={style.n_p}>
      В офисе «КОСМОС Телеком» по адресу
      <span>
        <a
          href={`${process.env.REACT_APP_SITE_URL}/about/contacts`}
        >
          г. Минск, ул. Красная, 6 (платежно-справочный терминал)
        </a>
      </span>
    </p>
    <p className={style.n_p}>
      В отделениях
      <span><a href="http://www.belpost.by/">РУП «Белпочта»</a></span>
      {' '}
      г.
      Минска
    </p>

  </div>
)
